import { jsx } from 'react/jsx-runtime';
import { styled } from 'styled-components';
import { useStickyGrid } from './context.mjs';
"use strict";
function StickyGridOverlay({
  children,
  topOffset,
  ...props
}) {
  const context = useStickyGrid();
  return /* @__PURE__ */jsx(StyledStickyGridOverlayWrap, {
    ...props,
    children: /* @__PURE__ */jsx(StyledStickyGridOverlay, {
      topOffset,
      children: typeof children === "function" ? children(context) : children
    })
  });
}
const StyledStickyGridOverlayWrap = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 2;
`;
const StyledStickyGridOverlay = styled.div`
  position: sticky;
  top: ${({
  topOffset
}) => topOffset ?? 0}px;
  bottom: 0;

  height: calc(100vh - ${({
  topOffset
}) => topOffset ?? 0}px);
  max-height: 100%;
`;
export { StickyGridOverlay };
//# sourceMappingURL=StickyGridOverlay.mjs.map
